import React from "react";
import "./project.css";
import {
  Timeline,
  Events,
  ImageEvent,
  createTheme,
  themes
} from "@merc/react-timeline";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
// import Image from "react-bootstrap/Image";

//Css file
import "./project.css";

//Projects

import Adporras from "../../assets/img/projects/adporras.jpg";
// import QuizApp from "../../assets/img/projects/imagen2.jpg";
import EquipoDocente from "../../assets/img/projects/equipodocente.jpg";
import EntidadesSoporte from "../../assets/img/projects/entidades_de_soporte.jpg";

//Skills (icons kept commented out for reference)
// import L_HTML5 from "../../assets/img/skills/html-5.svg";
// import L_CSS3 from "../../assets/img/skills/css3.svg";
// import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
// import L_REACT from "../../assets/img/skills/react.svg";
// import L_MATERIALUI from "../../assets/img/skills/material-ui-1.svg";
// import L_REACT_BOOTSTRAP from "../../assets/img/skills/react-bootstrap.svg";
// import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
// import L_FIREBASE from "../../assets/img/skills/firebase-icon.svg";

// Custom timline theme
const customTheme = createTheme(themes.default, {
  card: {
    backgroundColor: "#efefef"
  },
  date: {
    backgroundColor: "#64172e"
  },
  marker: {
    borderColor: "#070d59"
  },
  timelineTrack: {
    backgroundColor: "#64172e"
  }
});

const ProjectTimeline = () => {
  return (
    <div id="projects" className="projects">
      <h1 className="pt-3 text-center font-details pb-2">Nuestros Colaboradores</h1>
      <Timeline theme={customTheme}>
        <Events>
          <ImageEvent
            date=""
            className="text-center"
            text=""
            src={Adporras}
            alt="ExpenseTracker"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      Detalles
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Dra. Adriana Porras Moreno, MSc.</strong>
                        <br />
                        <strong>Directora del Proyecto Drepanocitico.</strong>
                        {/* <hr />
                        <strong>Puntos clave:</strong>
                        <ul className="list-styles pt-1">
                          <li>Lorem ipsum dolor sit amet</li>
                          <li>Lorem ipsum dolor sit amet</li>
                          <li>Lorem ipsum dolor sit amet</li>
                        </ul>
                        <hr />
                        <strong>Detalles con icono:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_HTML5}
                                alt="HTML 5"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CSS3}
                                alt="CSS 3"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_JAVASCRIPT}
                                alt="JavaScript"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              JavaScript
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_FIREBASE}
                                alt="Firebase"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Firebase
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_BOOTSTRAP}
                                alt="bootstrap"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Bootstrap
                            </span>
                          </li>
                        </ul> */}
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
              {/* <div className="d-flex justify-content-between flex-nowrap text-center">
                <UrlButton
                  href="https://expensetracker-1149f.web.app/"
                  target="_blank"
                >
                  SEE LIVE
                </UrlButton>
                <UrlButton
                  href="https://github.com/AdibaAbid/Expense-TrackerApp"
                  target="_blank"
                >
                  SOURCE CODE
                </UrlButton>
              </div>*/}
            </div>
          </ImageEvent>

          {/* Equipo Docente */}
          <ImageEvent
            date=""
            className="text-center"
            text=""
            src={EquipoDocente}
            alt="Equipo Docente"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      Detalles
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Equipo Docente y Colaboradores</strong>
                        <hr />
                        <ul className="list-styles pt-1">
                          <li>
                            <strong>Dra. Carolina Orduz Ilidge, MD.</strong><br />
                            Hematóloga Pediátrica<br />
                            Código Médico 13077<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Karol Acevedo Viales, MD</strong><br />
                            Hematóloga Pediátrica<br />
                            Código Médico 11753<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Walter Cartín Sanchez, MQC.</strong><br />
                            Microbiología y química clínica, especialista en hematología.<br />
                            Código profesional MQC 823<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Gabriela Abarca Mora, MQC</strong><br />
                            Microbiología y química clínica, especialista en parasitología médica.<br />
                            Código profesional MQC 801<br />
                            Laboratorio de Tamizaje Neonatal, Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Mariela Solano Vargas, MQC</strong><br />
                            Microbiología y química clínica, especialista en hematología.<br />
                            Código profesional MQC 1633<br />
                            Laboratorio de Tamizaje Neonatal, Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Simón Benjamín Curling, MD.</strong><br />
                            Urólogo Pediátrico<br />
                            Código Médico 6372<br />
                            Clínica PerteneSer, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Sixto Bogantes Ledezma, MD</strong><br />
                            Neurólogo<br />
                            Código Médico 8914<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Roberto Bogarin Solano, MD.</strong><br />
                            Endocrinólogo pediatrica<br />
                            Código Médico 6028<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Carlos Luis Abarca Campos, MD.</strong><br />
                            Ortopedista y Traumatólogo Pediátrico<br />
                            Código Médico 11053<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Manuel Enrique Soto Martínez, MD, MSc.</strong><br />
                            Neumólogo Pediátrico<br />
                            Código Médico 6819<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Gloriana Soto Montero, MD.</strong><br />
                            Vascular Periférico<br />
                            Código Médico 13716<br />
                            Centro Médico La California Oeste, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Maritza Ingoberg Rojas Calderón, MD.</strong><br />
                            Nefróloga Pediátrica<br />
                            Código Médico 10055<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Carlos Mas Romero, MD.</strong><br />
                            Cardiólogo Pediátrico<br />
                            Código Médico 4090<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Lic. Ligia Marín Vargas</strong><br />
                            Licenciada en Trabajo Social<br />
                            Código profesional 1218<br />
                            Hospital Nacional de Niños, Costa Rica.
                          </li>
                          <li>
                            <strong>Dra. Jen-Weng Fang Sung, MD</strong><br />
                            Oftalmóloga<br />
                            Código médico 4942<br />
                            Hospital Nacional de Niños, Costa Rica.
                          </li>
                          <li>
                            <strong>Dr. Byron Salvador Figueroa Ortiz, MD.</strong><br />
                            Médico internista y Hematólogo<br />
                            Código médico Guatemala 200191<br />
                            Código médico Uruguay 199862<br />
                            Hospital Británico, Montevideo Uruguay
                          </li>
                          <li>
                            <strong>Dra. Gabriela Naranjo Zuñiga, MD</strong><br />
                            Infectóloga Pediatra<br />
                            Código Médico 9129<br />
                            Hospital Nacional de Niños, Costa Rica.
                          </li>
                          <li>
                            <strong>Dra. Tannia Protti Meléndez, MD</strong><br />
                            Hematóloga Pediatra<br />
                            Código Médico 10195<br />
                            Zona Pediatrica, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Diana Campos Rodriguez, MQC</strong><br />
                            Microbiología y química clínica, especialista en inmunohematología y banco de sangre<br />
                            Código profesional MQC 1699<br />
                            Hospital Nacional de Niños, Costa Rica.
                          </li>
                          <li>
                            <strong>Dra. Kimberly Miranda Rojas, MD.</strong><br />
                            Hematóloga de Adultos<br />
                            Código Médico 12413<br />
                            Hospital México, Costa Rica
                          </li>
                          <li>
                            <strong>Dra. Karla Chaves Herrera, MD.</strong><br />
                            Hematología Pediátrica<br />
                            Código Médico Costa Rica 7266<br />
                            Código Médico Brasil  CREMESP 253305<br />
                            Hospital Regional de Cotia, Sao Paulo, Brasil
                          </li>
                          <li>
                            <strong>Dra. Cinthia Cespedes Hidalgo, MD.</strong><br />
                            Medicina Paliativa en Adultos<br />
                            Código Médico 9739<br />
                            Unidad de Cuidados Paliativos, Hospital Nacional de Niños, Costa Rica.
                          </li>
                          <li>
                            <strong>Dra. Cristina Castro Sancho, MSc</strong><br />
                            Odontóloga, especialista en odontología general avanzada y en Odontopediatría<br />
                            Máster en Docencia Universitaria.<br />
                            Código Profesional 1498096<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Carlos Andrés Portilla Figueroa, MD</strong><br />
                            Hemato oncólogo Pediatra<br />
                            Código Médico 7600108357<br />
                            Presidente de la Asociación Colombiana de Hematología y Oncología Pediátrica.<br />
                            Profesor de la Universidad del Valle Clínica Imbanaco, Colombia.
                          </li>
                          <li>
                            <strong>Dr. Sebastian Morera Vega, Msc</strong><br />
                            Psicólogo clínico, especialista en psicología infanto juvenil, y cuidados paliativos.<br />
                            Código profesional 4090<br />
                            Hospital Nacional de Niños, Costa Rica
                          </li>
                          <li>
                            <strong>Dr. Álvaro Fabian Jiménez Morales, MD</strong><br />
                            Hematólogo<br />
                            Código Médico 8354<br />
                            Hospital San Juan de Dios
                          </li>
                          <li>
                            <strong>Dra. Celina Vargas Arguedas, MD.</strong><br />
                            Fisiatra, experta en rehabilitación infantil.<br />
                            Código Médico 13218<br />
                            Hospital Nacional de Niños, Costa Rica.
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            </div>
          </ImageEvent>

          {/* Entidades de Soporte */}
          <ImageEvent
            date=""
            className="text-center"
            text=""
            src={EntidadesSoporte}
            alt="Entidades de Soporte"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      Detalles
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Entidades de Soporte</strong>
                        <hr />
                        <ul className="list-styles pt-1">
                          <li>St Jude Children Research Hospital, apoyo financiero.</li>
                          <li>Asociación Costarricense de Pediatría, ACOPE, aval académico.</li>
                          <li>Fundación para la investigación y apoyo a las personas con drepanocitosis y otras hemoglobinopatías, FUNDREPA,  acompañamiento.</li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            </div>
          </ImageEvent>

          {/* QuizApp */}

          {/* <ImageEvent
            date=""
            className="text-center"
            text="Paciente 2"
            src={QuizApp}
            alt="Quizz App"
          >
            <div className="d-flex justify-content-between flex-column mt-1">
              <div>
                <Accordion>
                  <Card>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey="0"
                      className="p-2 text-center accordian-main"
                    >
                      Detalles del proyecto
                    </Accordion.Toggle>

                    <Accordion.Collapse eventKey="0" className="text-left">
                      <Card.Body>
                        <strong>Description:</strong> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.
                        <hr />
                        <strong>Features:</strong>
                        <ul className="list-styles pt-1">
                          <li>Lorem ipsum dolor sit amet</li>
                          <li>Lorem ipsum dolor sit amet</li>
                          <li>Lorem ipsum dolor sit amet</li>
                        </ul>
                        <hr />
                        <strong>Detalles con icono:</strong>
                        <ul>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_HTML5}
                                alt="HTML 5"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              HTML5
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_CSS3}
                                alt="CSS 3"
                                rounded
                                className="image-style m-1"
                              ></Image>{" "}
                              CSS3
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_JAVASCRIPT}
                                alt="JavaScript"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              JavaScript
                            </span>
                          </li>
                          <li>
                            <span className="p-2">
                              <Image
                                src={L_BOOTSTRAP}
                                alt="bootstrap"
                                rounded
                                className="image-style1 m-1"
                              ></Image>{" "}
                              Bootstrap
                            </span>
                          </li>
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              </div>
            </div>
          </ImageEvent> */}

          {/* //MusicListApp */}
        </Events>
      </Timeline>
    </div>
  );
};

export default ProjectTimeline;
